import { render, staticRenderFns } from "./StepProgressBox.vue?vue&type=template&id=60605010&scoped=true"
import script from "./StepProgressBox.vue?vue&type=script&lang=js"
export * from "./StepProgressBox.vue?vue&type=script&lang=js"
import style0 from "./StepProgressBox.vue?vue&type=style&index=0&id=60605010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60605010",
  null
  
)

export default component.exports